<template>
  <section>
    <b-card
      header-tag="header"
      border-variant="info"
      header-bg-variant="light-info"
      header-class="p-1"
      class="border mb-0 mt-1"
      no-body
      style="max-height: 70vh"
    >
      <template #header>
        <h5 class="m-0 text-uppercase font-weight-bolder">
          {{ $t('agency.agencyF3.title') }}
        </h5>
      </template>
      <b-table
        ref="refEmployeeListTable"
        style="max-height: 55vh"
        :sticky-header="true"
        class="position-relative"
        :items="agencyData"
        responsive
        :fields="tableAgenciesF3"
        primary-key="id"
        show-empty
        :empty-text="$t('noMatchingResult')"

        no-border-collapse
        small
      >
        <template
          v-for="column in tableAgenciesF3"
          #[`head(${column.key})`]="data"
        >
          <span
            :key="column.label"
            class="text-dark text-nowrap"
          >
            {{ $t(`agency.agencyF3.columns.${data.label}`) }}
          </span>
        </template>

        <template #cell(no)="data">
          <span class="font-weight-bold">{{ data.index + 1 }}</span>
        </template>

        <template #cell(agcCode)="data">
          <div class="text-nowrap">
            <b-link
              :to="{
                name: 'apps-agencies-edit',
                params: { id: data.item.id },
              }"
              :disabled="!canAccess('employee.detailEmployee')"
              class="font-weight-bold d-block text-nowrap text-info"
            >
              <span class="align-text-top text-capitalize font-weight-bold">
                {{ data.item.agencyCode }}
              </span>
            </b-link>
          </div>
        </template>

        <template #cell(agcInfo)="data">
          <b-media
            vertical-align="center"
            class="d-flex-center"
          >
            <template #aside>
              <b-avatar
                size="40"
                :src="data.item.avatar"
                :text="avatarText(`${data.item.agencyName}`)"
                variant="light-primary"
              />
            </template>
            <h5>
              <span class="font-weight-bold d-block text-nowrap">

                {{ data.item.agencyName }}
              </span>
            </h5>
          </b-media>
        </template>
        <template #cell(owner)="data">
          <b-media
            no-body
            class="d-flex-center"
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-info"
                size="34"
              >
                <feather-icon
                  size="18"
                  icon="TagIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0 text-nowrap">
                {{ data.item.agencyOwner.name || 'N/A' }}
              </h6>
            </b-media-body>
          </b-media>
        </template>
        <template #cell(email)="data">
          <b-media
            no-body
            class="d-flex-center"
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-info"
                size="34"
              >
                <feather-icon
                  size="18"
                  icon="MailIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0 text-nowrap">
                <span>{{ data.item.emailAddress || 'N/A' }}</span>
              </h6>
              <small class="text-nowrap">
                {{
                  data.item.createdBy
                    ? `${data.item.createdBy.firstName} ${data.item.createdBy.lastName}`
                    : ''
                }}</small>
            </b-media-body>
          </b-media>
        </template>
        <template #cell(created)="data">
          <b-media
            no-body
            class="d-flex-center"
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-info"
                size="34"
              >
                <feather-icon
                  icon="ClockIcon"
                  size="18"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0 text-nowrap">
                {{ dateTime(data.item.createdAt) }}
              </h6>
              <small class="text-nowrap">
                {{
                  data.item.createdBy
                    ? `${data.item.createdBy.firstName} ${data.item.createdBy.lastName}`
                    : ''
                }}</small>
            </b-media-body>
          </b-media>
        </template>
        <template #cell(updated)="data">
          <b-media
            no-body
            class="d-flex-center"
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                variant="light-info"
                size="34"
              >
                <feather-icon
                  icon="EditIcon"
                  size="18"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0 text-nowrap">
                {{ dateTime(data.item.updatedAt) }}
              </h6>
              <small class="text-nowrap">
                {{
                  data.item.updatedBy
                    ? `${data.item.updatedBy.firstName} ${data.item.updatedBy.lastName}`
                    : ''
                }}</small>
            </b-media-body>
          </b-media>
        </template>
      </b-table>
    </b-card>
  </section>
</template>

<script>
import {
  BCard,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BMediaBody, BMediaAside,
} from 'bootstrap-vue'

import { avatarText, dateTime } from '@core/utils/filter'

import useEmployeeHandle from '@employee/useEmployeeHandle'

import useAgenciesHandle from '@agencies/useAgenciesHandle'

export default {
  components: {
    BMediaBody,
    BMediaAside,
    BCard,
    BTable,
    BMedia,
    BAvatar,
    BLink,
  },
  props: {
    agencyData: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const {
      tableAgenciesF3,
    } = useAgenciesHandle()
    const {
      refEmployeeListTable,
    } = useEmployeeHandle()

    return {
      dateTime,
      refEmployeeListTable,
      avatarText,
      tableAgenciesF3,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
